import {useTranslation} from "react-i18next";
import {Page} from "../components/common";
import {Container, Typography} from "@mui/material";

export const InvoicesPage = () => {
    const {t} = useTranslation(['navigation']);
    const title = t('invoices');
    return <Page title={`${title} | Kocha`}>
        <Container maxWidth="xl">
            <Typography variant="h4">{title}</Typography>
        </Container>
    </Page>
}
